<template>
    <b-row no-gutters
        id="products">
        <b-col cols="1"></b-col>
        <b-col>
            <h1 class="textTitle blueBarbos">
                OS NOSSOS PRODUTOS
            </h1>
            <h3 class="textSubTitle blueBarbos">
                Conheça a gama dos produtos que comercializamos
            </h3>
            <vueper-slides :visible-slides="3"
                class="no-shadow"
                :dragging-distance="70"
                :slide-ratio="1/4"
                :bullets="false">
                <vueper-slide v-for="(slide, i) of slides"
                    :key="i"
                    :title="slide.title"
                    :content="slide.content">
                    <div slot="slideContent">
                        <b-img :src="slide.image"
                            fluid
                            class="showcase"></b-img>
                    </div>
                </vueper-slide>
            </vueper-slides>
        </b-col>
        <b-col cols="1"></b-col>
    </b-row>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
    name: 'Products',
    components: {
        VueperSlides,
        VueperSlide
    },
    data () {
        return {
            slides: [
                {
                    title: 'Pescado Fresco',
                    content: 'Qualidade e frescura diariamente',
                    image: '/assets/img/peixe_250.png'
                },
                {
                    title: 'Marisco',
                    content: 'Deliciosos frutos do mar',
                    image: '/assets/img/marisco_250.png'
                },
                {
                    title: 'Moluscos',
                    content: 'As melhores espécies disponíveis',
                    image: '/assets/img/polvo_250.png'
                },
                {
                    title: 'Bivalves',
                    content: 'Sabores únicos e especiais',
                    image: '/assets/img/bivalves_250.png'
                },
                {
                    title: 'Congelados',
                    content: 'Elevado grau de qualidade',
                    image: '/assets/img/camarao_250.png'
                },
                {
                    title: 'Legumes',
                    content: 'Para complemento das refeições',
                    image: '/assets/img/ervilhas_250.png'
                }
            ]
        }
    }
}
</script>
